import {getAwayHomeTeams} from '@/utils/helpers';
import {getFormattedDate} from '@/utils/injections';


/**
 * Returns the away and home teams of an event.
 *
 * @param {Object} event - The event object.
 * @return {Object} - An object containing the away and home teams.
 */
export function eventTeams(event, attributesData) {
  return getAwayHomeTeams(event, attributesData);
}

/**
 * Returns the title of an event.
 * If the event has exactly two participants, the title is formatted as "awayTeam @ homeTeam".
 * Otherwise, the event's name is returned.
 *
 * @param {Object} event - The event object.
 * @return {string} - The title of the event.
 */
export function eventTitle(event) {
  const {participants, name} = event;
  if (!Array.isArray(participants) || participants.length !== 2) return name;

  const {homeTeam, awayTeam} = eventTeams(event);

  const getDisplayName = (team) => team?.shortName?.trim() || team?.name || '';

  return `${getDisplayName(awayTeam)} @ ${getDisplayName(homeTeam)}`;
}

/**
 * Returns an object containing the formatted date of the event.
 * The date is formatted into month, day, hour, and timezone.
 *
 * @param {Object} event - The event object.
 * @return {Object} - An object containing the formatted date of the event.
 */
export function eventTimeObject(event) {
  const {
    month,
    day,
    hh,
    zone,
  } = getFormattedDate({
    ts: event.event_utc_ts,
    timeZone: event?.time_zone || '',
    formatsOptions: {
      month: {month: 'short'},
      day: {day: '2-digit'},
      hh: {
        hour: '2-digit',
        hourCycle: 'h12',
        minute: '2-digit',
      },
    },
  });
  return {
    month,
    day,
    hh,
    zone,
  };
}
